import { toPng } from 'html-to-image';
import { getNodesBounds } from 'reactflow';

// Spec §5.10 — görüntü ekranın gördüğünden değil, ÇİZİLİ bütün düğümlerin sınırlarından kurulur. Çağıran dışa aktarma
// süresince ReactFlow'un onlyRenderVisibleElements'ini kapatır (yoksa ekran dışı kartlar DOM'da yoktur).
export const EXPORT_PADDING = 40;
// Tarayıcı tuval sınırının altında kal (Chrome ~16k piksel/kenar).
export const EXPORT_MAX_SIDE = 16000;
export const EXPORT_BACKGROUND = '#F5F7FA';

export function exportFrame(bounds) {
  const rawWidth = bounds.width + EXPORT_PADDING * 2;
  const rawHeight = bounds.height + EXPORT_PADDING * 2;
  const scale = Math.min(1, EXPORT_MAX_SIDE / Math.max(rawWidth, rawHeight));
  return {
    width: Math.min(EXPORT_MAX_SIDE, Math.ceil(rawWidth * scale)),
    height: Math.min(EXPORT_MAX_SIDE, Math.ceil(rawHeight * scale)),
    scale,
    x: (EXPORT_PADDING - bounds.x) * scale,
    y: (EXPORT_PADDING - bounds.y) * scale,
  };
}

function download(dataUrl) {
  const link = document.createElement('a');
  link.download = 'org-chart.png';
  link.href = dataUrl;
  link.click();
}

// `include` ("Seçili Dal"): yalnız bu düğüm ve kenar kimlikleri görüntüye girer.
export function exportFilter(el, include = null) {
  const classes = el?.classList;
  if (classes?.contains('react-flow__minimap') || classes?.contains('react-flow__controls')) return false;
  if (!include || !classes) return true;
  if (classes.contains('react-flow__node')) return include.nodeIds.has(el.getAttribute('data-id'));
  if (classes.contains('react-flow__edge')) {
    return include.edgeIds.has((el.getAttribute('data-testid') || '').replace(/^rf__edge-/, ''));
  }
  return true;
}

// Yalnız PNG: PDF sunucuda üretilir (orgChartPdf.js → POST /v1/org-chart/export/pdf).
export function exportFlowImage({
  flowEl, nodes, include = null,
}) {
  const viewport = flowEl?.querySelector('.react-flow__viewport');
  if (!viewport || !nodes?.length) return Promise.resolve(false);
  const frame = exportFrame(getNodesBounds(nodes));
  return toPng(viewport, {
    backgroundColor: EXPORT_BACKGROUND,
    width: frame.width,
    height: frame.height,
    pixelRatio: frame.scale < 1 ? 1 : 2,
    // Mini harita ve yakınlaştırma düğmeleri görüntüye girmez (spec 2026-10-24 §10).
    filter: (el) => exportFilter(el, include),
    style: {
      width: `${frame.width}px`,
      height: `${frame.height}px`,
      transform: `translate(${frame.x}px, ${frame.y}px) scale(${frame.scale})`,
    },
  })
    .then((dataUrl) => {
      download(dataUrl);
      return true;
    })
    .catch(() => false);
}
